
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {BaseSelectItemModel,
        SelectItemScreenElementModel} from '../../models/modelsFlow';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const SelectItemElementComponent: React.FC<{
  element: SelectItemScreenElementModel,
  onChange: (value: BaseSelectItemModel, element: SelectItemScreenElementModel) => void,
}> = ( {
  element,
  onChange
}) => {

  const handleChange = (event: any) => {
    const value = event.target.value;
    const selectedItem = element.items.find((thisItem: BaseSelectItemModel) => thisItem.key === value);
    if(selectedItem) onChange(selectedItem, element)
  }

  const required = true;

  const selectedItem = element.selectedItem;

  const error = () => {
    if(required && !selectedItem) return true
    return false
  };

  const displayValue = () => {
    if(selectedItem) return selectedItem.value;
    return ""
  }

  return (
      <FormControl
         fullWidth
         variant="filled"
         >
         <InputLabel
            required={required}
            error={error()}>
              Select
          </InputLabel>

         <Select
            value={displayValue()}
            onChange={(event) => handleChange(event)}
            size="small"
            disabled={false}
        >
           {element.items.map((thisItem: BaseSelectItemModel) => {
             return (
               <MenuItem
                 key={thisItem.key}
                 value={thisItem.value}
               >
                 {thisItem.value}
               </MenuItem>
             )}
           )}
         </Select>

      </FormControl>

    );

};
